
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardContent } from '@/components/ui/card';
import { Flame } from 'lucide-react';

const GasFlowRateKpi = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={200}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardContent className="p-6 flex flex-col items-center">
        <div className="bg-amber-100 dark:bg-amber-900/20 p-3 rounded-full mb-4">
          <Flame className="h-6 w-6 text-amber-600" />
        </div>
        <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">Peak Flow Rate</h3>
        <p className="text-3xl font-bold mt-2 text-amber-600">8.7 m³/h</p>
        <p className="text-sm text-gray-500 mt-1">Average peak time: 19:15</p>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasFlowRateKpi;
